module.exports = __webpack_public_path__ + "static/media/pin_yellow_highlighted.ce5d3cba.png";